import React from 'react';
import PropTypes from 'prop-types';
import Searcher from '../base/Searcher/Searcher';
import textTranslates from './translate.json';

const ProductSearchBox = (props) => {
    return(
        <Searcher
            title={textTranslates.productSearchBoxTitle}
            inputKeyPressed ={props.onSearchInputKeyPressed}
            inputTextChanged={props.onSearchInputTextChanged}
            inputType="text"
            inputPlaceholder={textTranslates.productSearchBoxPlaceholder}
            searchButtonClicked={props.onSearchButtonClicked}
            value={props.searchValue}/>
    );
};

ProductSearchBox.propTypes = {
    onSearchButtonClicked: PropTypes.func,
    onSearchInputKeyPressed: PropTypes.func,
    onSearchInputTextChanged: PropTypes.func,
    searchValue: PropTypes.string,
};

export default ProductSearchBox;


// WEBPACK FOOTER //
// ./src/components/Product/ProductSearchBox.js